<script setup lang="ts">
/** 공통 Allottee 반복표 ([[if allottees]] 재현) — ctx 로 행 추가/삭제. 문서 전체가 allottees 배열을 공유. */
import { inject, computed } from 'vue';
import { OTC_DOC_CTX } from '../otcContext';
import OtcDocVarField from '../OtcDocVarField.vue';

withDefaults(defineProps<{
  sharesHeader?: string;
  showTotal?: boolean;
  showIdNo?: boolean;   // Section 78: NRIC/Reg No 열 추가
}>(), { sharesHeader: 'No. of Shares Allotted', showTotal: true, showIdNo: false });

const ctx = inject(OTC_DOC_CTX)!;
const rows = computed(() => Array.from({ length: ctx.allotteeCount.value }, (_, i) => i + 1));
</script>

<template>
  <table class="cdd-tbl">
    <tbody>
      <tr>
        <th style="width:44px">#</th>
        <th :style="showIdNo ? 'width:48%' : 'width:64%'">Names of Allottee(s) <span class="cdd-cn">受配人姓名</span></th>
        <th v-if="showIdNo">NRIC / Reg. No.</th>
        <th>{{ sharesHeader }}</th>
        <th style="width:52px"></th>
      </tr>
      <tr v-for="(n, i) in rows" :key="n">
        <td>{{ i + 1 }}</td>
        <td>
          <OtcDocVarField :field-key="`allottee_name_${n}`" placeholder="Allottee Name" /><br />
          <OtcDocVarField :field-key="`allottee_address_${n}`" placeholder="Allottee Address" />
        </td>
        <td v-if="showIdNo"><OtcDocVarField :field-key="`allottee_id_no_${n}`" placeholder="NRIC / Reg. No." /></td>
        <td><OtcDocVarField :field-key="`allottee_shares_${n}`" placeholder="No. of Shares" /></td>
        <td>
          <button v-if="ctx.allotteeCount.value > 1" class="otc-rowbtn" title="Remove" @click="ctx.removeAllottee(i + 1)">✕</button>
        </td>
      </tr>
      <tr>
        <td :colspan="showIdNo ? 5 : 4">
          <button class="otc-addrow" @click="ctx.addAllottee()">+ Add allottee</button>
          <button
            v-if="ctx.canLoadMembers.value"
            class="otc-loadrow" :disabled="ctx.loadingMembers.value"
            title="Load the entity's existing members as allottees"
            @click="ctx.loadAllotteesFromMembers()"
          >
            <v-icon size="12">mdi-account-group-outline</v-icon>
            {{ ctx.loadingMembers.value ? 'Loading…' : 'Load from members' }}
          </button>
        </td>
      </tr>
      <tr v-if="showTotal">
        <td :colspan="showIdNo ? 3 : 2" style="text-align:right"><b>Total</b></td>
        <td colspan="2"><OtcDocVarField field-key="total_new_shares" placeholder="Total New Shares" /></td>
      </tr>
    </tbody>
  </table>
</template>

<style scoped>
.otc-rowbtn { border:none; background:none; color:#c0392b; cursor:pointer; font-size:12px; }
.otc-addrow { border:1px dashed #9aa4b2; background:#f7f8fa; border-radius:6px; padding:2px 8px; font-size:11px; color:#3182F6; cursor:pointer; }
.otc-loadrow { margin-left:8px; display:inline-flex; align-items:center; gap:4px; border:1px solid #cfe0ff; background:#f0f6ff; border-radius:6px; padding:2px 8px; font-size:11px; color:#1B64DA; font-weight:700; cursor:pointer; }
.otc-loadrow:hover:not(:disabled) { background:#e2eeff; }
.otc-loadrow:disabled { opacity:.6; cursor:default; }
</style>
